/**
* 模版
**/

<template>
  <div style="width: 1200px; margin: 30px auto" v-loading="loading">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      class="demo-ruleForm shopCartBox"
    >
      <el-form-item>
        <el-row class="tableTitle">
          <el-col :span="4">
            <div class="grid-content">
              <el-checkbox
                :indeterminate="indeterminate"
                v-model="ischeckAll"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
            </div>
          </el-col>
          <el-col :span="6"
            ><div class="grid-content bg-purple-light">商品名称</div></el-col
          >
          <el-col :span="4"
            ><div class="grid-content bg-purple">单价</div></el-col
          >
          <el-col :span="6"
            ><div class="grid-content bg-purple-light">数量</div></el-col
          >
          <el-col :span="2"
            ><div class="grid-content bg-purple">小计</div></el-col
          >
          <el-col :span="2"
            ><div class="grid-content bg-purple-light">操作</div></el-col
          >
        </el-row>
        <div
          class="shopCard"
          v-for="(partition, partitionIndex) in list"
          :key="partitionIndex"
        >
          <div class="shopstoreItem">
            <el-row>
              <el-col :span="24">
                <div class="storeTitle grid-content">
                  <el-checkbox
                    :indeterminate="partition.indeterminate"
                    v-model="partition.checked"
                    @change="
                      handleCheckedCountryAllChange(
                        partitionIndex,
                        partition.bxmId,
                        $event
                      )
                    "
                    :key="partitionIndex"
                  >
                    {{ partition.name }}
                  </el-checkbox>
                </div>
              </el-col>
            </el-row>
            <div class="storeContent">
              <div v-for="(item, index) in partition.goods" :key="index">
                <el-row class="shopitem">
                  <el-col :span="4">
                    <div class="grid-content bg-purple-light">
                      <el-checkbox
                        v-model="item.checked"
                        @change="
                          handleCheckedCountryChange(
                            index,
                            item.scid,
                            partition.bxmId,
                            $event
                          )
                        "
                        :key="item.id"
                        ><el-image
                            class="goodsPhotos"
                          :src="`${item.photos}`"
                        ></el-image
                      ></el-checkbox>
                    </div>
                  </el-col>
                  <el-col :span="6"
                    ><div class="grid-content bg-purple-light goodsname">
                      <span style="cursor: pointer;" @click="$router.push(`/goodsDetail_supplie?id=${item.id}`)">{{ item.name }}</span>
                    </div>
                  </el-col>
                  <el-col :span="3"
                    ><div class="grid-content bg-purple-light">
                      <span> {{item.realprice || 0}}</span>
                      <!-- marketprice 需要乘以折扣 -->
                      <!-- <span>{{ item.marketprice }}</span> -->
                    </div></el-col
                  >
                  <el-col :span="6">
                    <div class="grid-content bg-purple-light">
                      <el-form-item prop="number">
                        <el-input-number
                          v-model="item.number"
                          @change="
                            handleNumChange(partition.bxmId, item.scid, item.number)
                          "
                          :min="1"
                          :max="10"
                          label="数量"
                        ></el-input-number>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="3">
                    <div class="grid-content bg-purple-light">
                      <!-- marketprice 需要乘以折扣 -->
                      <span class="totalNum">{{ Number(item.number * item.realprice).toFixed(2) }} 元</span>
                    </div>
                  </el-col>
                  <el-col :span="2">
                    <div class="grid-content bg-purple-light">
                      <el-button
                        type="danger"
                        size="mini"
                        @click="onDelete(partition.bxmId, item.scid)"
                        >删除</el-button
                      >
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
        <div v-if="list.length==0?true:false" class="gotoShop">
             <p>您的购物车还是空的!</p>
             <router-link class="gotoShopText" to="/goodsList">马上去购物</router-link>
          </div>
      </el-form-item>
    </el-form>
    <div class="bottomCount">
      <el-row :class="searchBarFixed == true ? 'isFixed' : ''">
        <el-col :span="6"
          ><div class="grid-content">
            <router-link to="/goodsList">继续购物</router-link>
          </div></el-col
        >
        <el-col :span="6"
          ><div class="grid-content totalNum">
            共 <strong>{{ status()[0] }}</strong> 件商品，已选择
            <strong>{{ status()[1] }}</strong> 件
          </div></el-col
        >
        <el-col :span="6"
          ><div class="grid-content totalNum">
            合计(不含运费):<strong class="totalSize">{{ sumPrice() }}</strong
            >元
          </div></el-col
        >
        <el-col :span="6"
          ><div class="grid-content">
            <el-button
              class="countedSize"
              type="danger"
              size=""
              @click="submitForm('ruleForm')"
              :disabled="status()[2]"
              >去结算</el-button
            >
          </div></el-col
        >
      </el-row>
    </div>
  </div>
</template>

<script>
import { shoppingCartlist,shoppingCartDelete } from "@/api/xunyou";

// scid: 购物车的id  每条记录都不一样唯一（同一个商品加两次）
// cid 商品id
// 导出模块
export default {
  // 模块名字
  name: "",
  // 模块数据
  data() {
    return {
      userInfo: this.$store.state.userInfo,
      searchBarFixed: true, // 监听滚动条
      loading: false,
      ruleForm: {
        type: [],
        number: 1,
      },
      rules: {
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change",
          },
        ],
      },
      total: 0,
      list:[],
      // list: [
      //   {
      //     name: "SKII旗舰店",
      //     checked: false,
      //     bxmId: 1000,
      //     goods: [
      //       {
      //         id: 1001,
      //         name: "POLA/宝丽碧艾B.A 洁面膏100g温和清洁泡沫",

      //         number: 2,
      //         price: 480,
      //         checked: false,
      //       },
      //       {
      //         id: 1002,
      //         name: "SK-II大红瓶面部护肤精华面霜提",

      //         number: 2,
      //         price: 480,
      //         checked: false,
      //       },
      //       {
      //         id: 1003,
      //         name: "SK-II大红瓶面部护肤精华面霜提",

      //         number: 2,
      //         price: 480,
      //         checked: false,
      //       },
      //     ],
      //   },
      //   {
      //     name: "腾信智慧官方自营店",
      //     checked: false,
      //     bxmId: 2,

      //     goods: [
      //       {
      //         id: "5",
      //         name: "长虹 55D5P 55英寸智慧屏教育电",
      //         number: 1,
      //         price: 880,
      //         checked: false,
      //       },
      //       {
      //         id: "6",
      //         name: "长虹 55D5P 55英寸智慧屏教育电",
      //         number: 1,
      //         price: 880,
      //         checked: false,
      //       },
      //     ],
      //   },
      //   {
      //     name: "小米官方旗舰店",
      //     checked: false,
      //     bxmId: 3,

      //     goods: [
      //       {
      //         id: "7",
      //         name: "",
      //         number: 1,
      //         price: 11480,
      //         checked: false,
      //       },
      //       {
      //         id: "8",
      //         name: "瑞士",
      //         number: 1,
      //         price: 11480,
      //         checked: false,
      //       },
      //     ],
      //   },
      // ],
      ischeckAll: false,
      indeterminate: false,
      rules: {
        senderName: [
          { required: true, message: "字段不能为空", trigger: "blur" },
        ],
        website: [{ required: true, message: "字段不能为空", trigger: "blur" }],
      },
    };
  },
  // 注册组件
  components: {
    // headerComponent
  },
  // 监听指定值，只有指定值变化，才会触发
  watch: {},
  mounted() {
    if(this.userInfo.loginName!=null||this.userInfo.loginName!="" ){
          this.getshoppingCartlist();
    }
    //   window.addEventListener('scroll', this.handleScroll,true)
  },
  // 销毁完成状态(里面是操作)
  destroyed() {
    //    window.removeEventListener('scroll', this.handleScroll,true)
  },
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
    //   监听滚动条(判断有问题)
    handleScroll() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;

      // 避免没有数据的时候 重复执行 scrollHeight > clientHeight
      if (
        scrollHeight > clientHeight &&
        scrollTop + clientHeight === scrollHeight
      ) {
        this.searchBarFixed = false;
      } else {
        this.searchBarFixed = true;
      }
    },
    // 购物车查询
    getshoppingCartlist() {
      console.log("购物车查询");
      this.loading = true;
      shoppingCartlist({uid:this.userInfo.userId||''})
        .then((res) => {
          //   if (res.code == 0) {
          console.log("res", res);
          this.loading = false;
          let newList = res.map((x)=>{
            return x.bxunyouMerchant;
          })
           console.log(newList)
           console.dir(this.list)

            this.list = newList;
          //   } else {
          // this.$message({
          //   type: 'info',
          //   message: res.msg
          // })
          //   }
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("查询购物车失败，请稍后再试！");
        });
    },
    // 选择状态判断
    status() {
      let allProduct = 0;
      let selectProduct = 0;
      this.list.forEach((x) => {
        if (x && x.goods.length) {
          allProduct += x.goods.length;
          x.goods.forEach((items) => {
            if (items.checked) {
              selectProduct += 1;
            }
          });
        }
      });
      let isSelect = selectProduct === 0;
      return [allProduct, selectProduct, isSelect];
    },
    // 总计
    sumPrice() {
      let total = 0;
      this.list.forEach((items) => {
        if (items && items.goods) {
          let sum = items.goods.reduce((sum, item) => {
            if (item.checked) {
              // <!-- marketprice 需要乘以折扣 -->
              // return sum + item.marketprice * item.number; // 隐式转换
              return sum + item.realprice * item.number; // 隐式转换
            } else {
              return sum + 0;
            }
          }, 0);
          total += sum;
        }
      });
      return total;
    },
    // 删除
    onDelete(bxmId, id) {
      console.log(bxmId, id);
    //   // 前端删除
    //   this.list.forEach((x) => {
    //     if (x.bxmId === bxmId) {
    //       for (let i = x.goods.length - 1; i >= 0; i--) {
    //         try {
    //           if (x.goods[i].id === id) {
    //             x.goods.splice(i, 1);
    //           }
    //           throw new Error("EndIterative");
    //         } catch (e) {
    //           if (e.message != "EndIterative") throw e;
    //         }
    //       }
    //     }
    //   });
    //   for (let i = this.list.length - 1; i >= 0; i--) {
    //     try {
    //       if (this.list[i].goods.length === 0) {
    //         this.list.splice(i, 1);
    //       }
    //       throw new Error("EndIterative");
    //     } catch (e) {
    //       if (e.message != "EndIterative") throw e;
    //     }
    //   }
      // // 后端删除
      shoppingCartDelete({
        ids:id
      }).then((res) => {
          console.log(res)
          if(res.code === 0){
              this.getshoppingCartlist();
            this.$message.error("删除成功！");
          }
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("删除失败，请稍后再试！");
        });
    },
    // 改变数量 实时计算
    handleNumChange(bxmId, id, number) {
      console.log(bxmId, id, number,'id是什么')
      this.list.forEach((x) => {
        if (x.bxmId === bxmId) {
          x.goods.forEach((items) => {
            if (items.id === id) {
              items.number = number;
            }
          });
        }
      });
    },
    // 提交
    submitForm(formName) {
      console.log(this.list)
      let selectList = [];
     this.list.forEach((x)=>{
        //    if(x.checked){
        let canPush = false;
           let obj = {};
        let goodList = [];
                x.goods.forEach((items)=>{
                    if(items.checked){
                          canPush = true;
                          let child = {
                          ...items
                          }
                        goodList.push(child)
                    }
                })
        obj = {
        ...x,
        goods:goodList
        }
        if(canPush){
        selectList.push(obj)
        }
        //    }
        })
      console.log(selectList)
     sessionStorage.setItem("selectList", JSON.stringify(selectList));
      this.$router.push('/orderDetail_supplie')
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleCheckAllChange(e) {
      //一级change事件
      this.ischeckAll = e;
      this.indeterminate = false;
      for (var i = 0, len = this.list.length; i < len; i++) {
        //二级全选反选
        this.list[i].checked = e;
        this.list[i].indeterminate = false; //去掉二级不确定状态
        for (var j = 0, len1 = this.list[i].goods.length; j < len1; j++) {
          //三级全选反选
          this.list[i].goods[j].checked = e;
        }
      }
    },
    handleCheckedCountryAllChange(index, topId, e) {
      //二级change事件
      this.list[index].checked = e; //二级勾选后，子级全部勾选或者取消
      this.list[index].indeterminate = false; //去掉二级不确定状态
      var childrenArray = this.list[index].goods;
      if (childrenArray)
        for (var i = 0, len = childrenArray.length; i < len; i++)
          childrenArray[i].checked = e;

      this.getIsCheckAll();
    },
    handleCheckedCountryChange(topIndex, sonId, topId, e) {
      console.log(this.list,topIndex, sonId, topId, e,'goyxuan')
      //三级change事件
      var childrenArray = this.list[topIndex].goods;
      var tickCount = 0,
        unTickCount = 0,
        len = childrenArray.length;
      for (var i = 0; i < len; i++) {
        if (sonId == childrenArray[i].id) childrenArray[i].checked = e;
        if (childrenArray[i].checked == true) tickCount++;
        if (childrenArray[i].checked == false) unTickCount++;
      }
      if (tickCount == len) {
        //三级级全勾选
        this.list[topIndex].checked = true;
        this.list[topIndex].indeterminate = false;
      } else if (unTickCount == len) {
        //三级级全不勾选
        this.list[topIndex].checked = false;
        this.list[topIndex].indeterminate = false;
      } else {
        this.list[topIndex].checked = false;
        this.list[topIndex].indeterminate = true; //添加二级不确定状态
      }

      this.getIsCheckAll();
    },
    getIsCheckAll() {
      var tickCount = 0,
        unTickCount = 0,
        indeterminateCount = 0,
        ArrLength = this.list.length;
      for (var j = 0; j < ArrLength; j++) {
        //全选checkbox状态
        if (this.list[j].checked == true) tickCount++;
        if (this.list[j].checked == false) unTickCount++;
        if (this.list[j].indeterminate == true) indeterminateCount++;
      }
      if (tickCount == ArrLength) {
        //二级全勾选
        this.ischeckAll = true;
        this.indeterminate = false;
      } else if (unTickCount == ArrLength) {
        //二级全不勾选
        this.ischeckAll = false;
        if (indeterminateCount > 0) {
          this.indeterminate = true;
        } else {
          this.indeterminate = false;
        }
      } else {
        this.ischeckAll = false;
        this.indeterminate = true; //添加一级不确定状态
      }
    },
  },
};
</script>
<style scoped lang='less'>
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  height: 70px;
  line-height: 70px;
  padding: 0 20px;
  box-sizing: border-box;
  background: white;
}
.goodsname{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.shopCartBox {
  .tableTitle {
    border-bottom: 1px solid #efefef;
    .grid-content {
      padding: 0 15px;
    }
  }
  .shopstoreItem {
    margin-bottom: 40px;
    .goodsPhotos{
        width: 70px;
    }
    /deep/.el-input-number {
        vertical-align: text-top;
    }
  }
  /deep/span.el-checkbox__label {
    vertical-align: middle;
  }
  .shopitem.el-row {
    padding: 20px;
    background: white;
    box-sizing: border-box;
    border-bottom: 1px solid #efefef;
  }
  .storeTitle.grid-content {
    border-bottom: 1px solid #efefef;
  }
   .gotoShop {
      text-align: center;
      font-size: 30px;
      margin: 40px;
      color:rgb(176, 176, 176);
      .gotoShopText{
        font-size: 20px;
        padding: 10px 20px;
        box-sizing: border-box;
        border: 1px solid #ff6700;
        background: #ff6700;
        color: white;
        margin: 20px;
        display: inline-block;
      }
      .gotoShopText:hover{
        background: #ff6700c9
      }
  }
}
span.totalNum {
  color: #ff6700;
}
.bottomCount {
  margin-bottom: 40px;
  .isFixed {
    position: fixed;
    bottom: 0;
    left: 0%;
    width: 100%;
    margin: auto;
    z-index: 1;
  }
  .countedSize {
    width: 100%;
  }
  .totalNum {
    color: #ff6700;
    .totalSize {
      font-size: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views_supplier/shoppingcart/shoppingcart.vue